/* eslint-disable max-len */
import { APP_INITIALIZER, enableProdMode, ErrorHandler, NgModule } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


import { Router } from '@angular/router';
import { initializeApp } from 'firebase/app';

// Firebase configuration



if (environment.production) {
  enableProdMode();





}




platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
